//a utility function that returns true if the passed in string is a valid uuid
export default function isUuid(str) {
  const uuIdRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  let result = uuIdRegex.test(str)
  return result
}